const _ = {
  actions: {
    GetProductCateData({ commit, state }, params) {
      return mm
        .http({
          url: '/api/datasource/productCategory',
          method: 'get',
          params: {
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
    GetProductData({ commit, state }, params) {
      return mm
        .http({
          url: '/api/datasource/product',
          method: 'get',
          params: {
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
    GetProductCateList({ commit, state }, params) {
      return mm
        .http({
          url: '/api/productCategory/list',
          method: 'get',
          params: {
            a_langset_id: mm.store.state.currentLanguage,
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
    GetProductList({ commit, state }, params) {
      return mm
        .http({
          url: '/api/product/list',
          method: 'get',
          params: {
            a_langset_id: mm.store.state.currentLanguage,
            ...params
          }
        })
        .then(({ data }) => {
          return data
        })
    },
  }
}

export default _
